import { SupportedLanguage } from 'lib/lexemes/supported-languages';
import { GetServerSidePropsContext } from 'next';

type Slug = string[] | string | undefined;

function setPageSlug(slug: Slug) {
  let pageSlug = Array.isArray(slug) ? slug[0] : slug;

  if (!pageSlug) {
    pageSlug = '';
  }

  return pageSlug;
}

export async function setupLangAndUrlParams(
  query: GetServerSidePropsContext<{
    lang: SupportedLanguage;
    slug: string | string[];
  }>['query'],
  locale?: SupportedLanguage,
) {
  const redirectToMainPageWithLocalisation = false;
  const lang = setPageSlug(query.lang || locale);

  return {
    lang,
    // url,
    redirectToMainPageWithLocalisation,
  };
}

export function cleanUrlFromParams(url: string) {
  return url.split('?')[0];
}
